// extracted by mini-css-extract-plugin
export default {"default":"CountryInput__default-paaFs","icon":"CountryInput__icon-aF4QN"};